// @flow
import * as React from 'react';
import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import Container from 'components/Container';
import EventTracking from 'lib/EventTracking';
import LinkConstants from 'constants/LinkConstants';
import TitleHeader from 'components/TitleHeader';
import Row from 'components/Row';

type Props = {
  onContinue: () => void,
  onMount: () => void,
};

const prefixEvent = (suffix: string) =>
  `announcements.target_by_student_id.upload_list_null.low_student_id_percentage.${suffix}`;

export default class TargetByStudentIdNull extends React.Component<Props, *> {
  componentDidMount() {
    this.props.onMount();
    EventTracking.trackKey(prefixEvent('view'));
  }

  render() {
    return (
      <Container size="large" className="TargetByStudentId-nullState">
        <BoxBody>
          <TitleHeader
            image={require('assets/images/chat/TargetByStudentId/target_by_student_id_null.svg')}
            imageClassName={'TargetByStudentId-nullState-img'}
            size="small"
            title="Most of the students in your organization don't have student numbers on Remind"
            subtext="You'll only be able to message students with student numbers on Remind. To add student numbers to students, sync Remind with your SIS."
            action={
              <React.Fragment>
                <Row size="xsmall">
                  <Button
                    data-test="sync-button"
                    href={LinkConstants.ROSTERING_GUIDE}
                    target="_blank"
                    inline
                    eventKey={prefixEvent('sis_sync_cta.click')}>
                    Sync Remind with your SIS
                  </Button>
                </Row>
                <Button
                  data-test="continue-button"
                  onClick={this.props.onContinue}
                  level="text"
                  weight="semibold"
                  color="mascot"
                  eventKey={prefixEvent('continue_cta.click')}
                  inline>
                  Continue anyway
                </Button>
              </React.Fragment>
            }
          />
        </BoxBody>
      </Container>
    );
  }
}
